module.exports = __webpack_public_path__ + "img/nezha_message_bac.0c0dfb69.png";